<div class="panel panel-plan px-3">
	<h3 data-testid="SUBSYS2_PLANOVERVIEW_TITLE_TXT">{{ labels().PLAN_FORM_COMPONENT_OVERVIEW_TITLE }}</h3>

	<div class="panel-overview-container">
		@if (planFormSrv.isSaveVisible) {
		<div class="panel-overview-button">
			<button data-testid="SUBSYS2_PLANOVERVIEW_SAVE_BTN" type="button" class="btn d-flex align-items-center"
				[disabled]="planFormSrv.isSaveDisabled" (click)="planFormSrv.savePlan(false)">
				<span class="material-icons-outlined me-2">save</span>
				{{ labels().PLAN_FORM_COMPONENT_ANATOMICAL_SAVE_BUTTON }}
			</button>
		</div>
		}

		<div class="panel panel-overview">
			<div class="stepper pe-0 mb-3">
				<div class="stepper-icon bg-success"></div>
				<div data-testid="SUBSYS2_PLANOVERVIEW_PATIENT_TITLE_TXT" class="stepper-label border-0"
					[title]="labels().PLAN_FORM_COMPONENT_OVERVIEW_PATIENT_DATA">
					{{ labels().PLAN_FORM_COMPONENT_OVERVIEW_PATIENT_DATA }}
				</div>
			</div>
			<div class="row">
				<div class="col-12">
					<div class="overview-item">
						<span>{{ labels().PLAN_FORM_COMPONENT_OVERVIEW_PATIENT_ID }}</span>
						<small data-testid="SUBSYS2_PLANOVERVIEW_PATID_TXT" class="help-text" [title]="patient?.number">
							{{ patient?.number }}
						</small>
					</div>
					<div class="overview-item">
						<span>{{ labels().PLAN_FORM_COMPONENT_OVERVIEW_PATIENT_INITIALS }}</span>
						<small data-testid="SUBSYS2_PLANOVERVIEW_INITIALS_TXT" class="help-text" [title]="patient?.initials">
							{{ patient?.initials }}
						</small>
					</div>
					<div class="overview-item">
						<span>{{ labels().PLAN_FORM_COMPONENT_OVERVIEW_PATIENT_GENDER }}</span>
						<small data-testid="SUBSYS2_PLANOVERVIEW_GENDER_TXT" class="help-text" [title]="patient?.gender">
							{{ patient?.gender }}
						</small>
					</div>
				</div>
			</div>
		</div>
		<div class="panel panel-overview">
			<div class="stepper pe-0 mb-3">
				<div class="stepper-icon" [class.bg-success]="planFormSrv.isDataValid">1</div>
				<div data-testid="SUBSYS2_PLANOVERVIEW_PLANDATA_TITLE_TXT" class="stepper-label border-0"
					[title]="labels().PLAN_FORM_COMPONENT_OVERVIEW_PLAN_DATA">
					{{ labels().PLAN_FORM_COMPONENT_OVERVIEW_PLAN_DATA }}
				</div>
			</div>
			@let isTlhexDevice = form?.value?.device === deviceEnum.Tlhex;
			<div class="row">
				<div class="col-12">
					<div data-testid="SUBSYS2_PLANOVERVIEW_DEVICE_BOX" class="overview-item mb-2">
						@let device = form?.value?.device | deviceLabel;
						@if (device) {
						<button type="button" class="btn colored-chip px-3 text-uppercase">{{ device }}</button>
						} @else { - }
					</div>
					<div class="overview-item">
						<span>{{ labels().PLAN_FORM_COMPONENT_OVERVIEW_PLAN_ID }}</span>
						@let planIdCtrl = form?.controls?.planId;
						@let planIdTxt = planIdCtrl?.value || '';
						<small data-testid="SUBSYS2_PLANOVERVIEW_PLANID_TXT" class="help-text"
							[class.text-danger]="planIdCtrl?.dirty && planIdCtrl?.invalid" [title]="planIdTxt">
							{{ planIdTxt || '-' }}
						</small>
					</div>
					@if (isTlhexDevice) {
					<div class="overview-item">
						<span>{{ labels().PLAN_FORM_COMPONENT_OVERVIEW_PLAN_SCENARIO }}</span>
						@let postOp = form?.value?.postOperative;
						@let scenarioTxt = postOp === true ? labels().PLAN_FORM_COMPONENT_SCENARIO_POSTOPERATIVE : (postOp === false
						?
						labels().PLAN_FORM_COMPONENT_SCENARIO_PREOPERATIVE : '');
						<small data-testid="SUBSYS2_PLANOVERVIEW_PLANSCENARIO_TXT" class="help-text" [title]="scenarioTxt">
							{{ scenarioTxt || '-' }}
						</small>
					</div>
					<div class="overview-item">
						<span>{{ labels().PLAN_FORM_COMPONENT_OVERVIEW_PLAN_TYPE }}</span>
						@let planType = form?.value?.planType;
						@let planTypeTxt = planType ? (planType | planTypeLabel) : '';
						<small data-testid="SUBSYS2_PLANOVERVIEW_PLANTYPE_TXT" class="help-text" [title]="planTypeTxt">
							{{ planTypeTxt || '-' }}
						</small>
					</div>
					<div class="overview-item">
						<span>{{ labels().PLAN_FORM_COMPONENT_OVERVIEW_PLAN_REFERENCE }}</span>
						@let referenceType = form?.value?.referenceType;
						@let refTypeTxt = referenceType === referenceEnum.Proximal ? labels().PLAN_FORM_COMPONENT_REFERENCE_PROXIMAL
						:
						(referenceType === referenceEnum.Distal ? labels().PLAN_FORM_COMPONENT_REFERENCE_DISTAL : '');
						<small data-testid="SUBSYS2_PLANOVERVIEW_PLANREFERENCE_TXT" class="help-text" [title]="refTypeTxt">
							{{ refTypeTxt || '-' }}
						</small>
					</div>
					}
					<div class="overview-item">
						<span>{{ labels().PLAN_FORM_COMPONENT_OVERVIEW_PLAN_NOTES }}</span>
						@let notesTxt = form?.value?.notes ?? '';
						<small data-testid="SUBSYS2_PLANOVERVIEW_PLANNOTES_TXT" class="help-text" [title]="notesTxt">
							{{ notesTxt || '-' }}
						</small>
					</div>
				</div>
			</div>
		</div>
		<div class="panel panel-overview">
			<div class="stepper pe-0 mb-3">
				<div class="stepper-icon" [class.bg-success]="planFormSrv.isFormValid">2</div>
				<div data-testid="SUBSYS2_PLANOVERVIEW_PLANSETUP_TITLE_TXT" class="stepper-label border-0"
					[title]="labels().PLAN_FORM_COMPONENT_OVERVIEW_PLAN_SETUP">
					{{ labels().PLAN_FORM_COMPONENT_OVERVIEW_PLAN_SETUP }}
				</div>
			</div>
			<div class="row">
				<div class="col-12">
					<div class="overview-item">
						<span>{{ labels().PLAN_FORM_COMPONENT_OVERVIEW_ANALYSIS }}</span>
						@let setup = form?.value?.withImages;
						@let setupTxt = setup == true ? labels().PLAN_FORM_COMPONENT_SETUP_XRAYS : (setup == false ?
						labels().PLAN_FORM_COMPONENT_SETUP_NOIMAGES : '');
						<small data-testid="SUBSYS2_PLANOVERVIEW_PLANSETUP_TXT" class="help-text" [title]="setupTxt">
							{{ setupTxt || '-' }}
						</small>
					</div>
					<div class="overview-item">
						<span>{{ labels().PLAN_FORM_COMPONENT_OVERVIEW_PLAN_BONE_TYPE }}</span>
						@let boneTypeCtrl = form?.controls?.anatomicalSite;
						@let boneTypeTxt = boneTypeCtrl?.value ? (boneTypeCtrl!.value | anatomicalSiteLabel) : '';
						<small data-testid="SUBSYS2_PLANOVERVIEW_PLANBONE_TXT" class="help-text"
							[class.text-danger]="boneTypeCtrl?.value && boneTypeCtrl?.invalid" [title]="boneTypeTxt">
							{{ boneTypeTxt || '-' }}
						</small>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>